import Input from "../../customhtmlcomponents/Input";
import React, { FC, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../customhtmlcomponents/Button";
import axios from "../../../services/ApiConfig";
import { AxiosResponse } from "axios";
import { useHistory } from "react-router-dom";
import {
  IadministrateForeningPanelProps,
  IoppdaterForeningData,
  ResponseData,
} from "./types/types";
import { downloadFile } from "../../../utility/downloadFile";
import { URLS } from "../../../utility/UrlConstants";
import LoadingSpinnerComponent from "../../customhtmlcomponents/LoadingSpinnerComponent";

const AdministrateForeningPanel: FC<IadministrateForeningPanelProps> = ({
  forening,
  handleForeningChange,
  setModal,
  message,
  setCurrentForeningReportNumber,
  isViewer
}: IadministrateForeningPanelProps) => {
  const { register, setValue, handleSubmit, errors, control } =
    useForm<IoppdaterForeningData>();
  const [processing, isProcessing] = useState(false);
  const [active, setActive] = useState(forening.active);

  const processingStyle = `${
    processing ? "hover:opacity-100 hover:cursor-not-allowed" : null
  } bg-sk-primary-blue disabled:bg-gray-400 disabled:text-sk-button-unselected}`;
  const disabledStyle = processing ? true : undefined;
  const labelopts = { labelOn: true, defaultLabelStyle: true };
  const oppdaterForening = handleSubmit(
    ({
      id = forening.id,
      foreningsNummer,
      foreningsNavn,
      password,
      active,
      viewer
    }) => {
      isProcessing(true);
      console.log(active);
      axios
        .put(
          `${URLS.ADMIN_OPPDATER_FORENING_PUT}${forening.id}`,
          {
            id,
            foreningsNummer,
            foreningsNavn,
            password,
            active,
            viewer
          },
          {
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
            },
          }
        )
        .then((response: AxiosResponse<ResponseData>) => {
          if (response.data) {
            console.log("response data", response.data);
            let mess = response.data;
            console.log("message", mess);
            message({
              body: mess,
            });
            setModal(true);
            setTimeout(() => setModal(false), 2000);
          }
        })
        .catch((error) => {
          console.log("error", error.response);
          let mess = error?.response?.data;
          message({
            body: mess ?? "Noe gikk dessverre galt. Vennligst prøv igjen.",
          });
          setModal(true);
          setTimeout(() => setModal(false), 5000);
        })
        .then(() => isProcessing(false));
    }
  );
  const fjernForening = () => {
    if (
      window.confirm(
        `Er du sikker på at du vil fjerne foreningen ${forening.foreningsNavn}`
      )
    ) {
      isProcessing(true);
      axios
        .delete(`${URLS.ADMIN_SLETT_FORENING_DELETE}${forening.id}`)
        .then((response: AxiosResponse<ResponseData>) => {
          console.log(response);
          let mess = response.data;
          console.log("message", mess);
          message({
            body: mess,
          });
          setModal(true);
          setTimeout(() => setModal(false), 2000);
        })
        .catch((error) => {
          let mess = error?.response?.data;
          message({
            body: mess ?? "Noe gikk dessverre galt. Vennligst prøv igjen.",
          });
          setModal(true);
          setTimeout(() => setModal(false), 5000);
        })
        .then(() => isProcessing(false));
    }
  };

  const history = useHistory();
  const openForeningRapport = () => {
    const foreningsNummer = forening.foreningsNummer;
    console.log("i admin panel", foreningsNummer);
    setCurrentForeningReportNumber(foreningsNummer);
    history.push({ pathname: "/lokalforening", state: foreningsNummer });
  };

  const downloadReport = () => {
    isProcessing(true);
    axios
      .get(`${URLS.LASTNED_RAPPORT_GET}${forening.foreningsNummer}`, {
        responseType: "blob",
      })
      .then((r) => {
        downloadFile(r, "pdf", -1, forening.foreningsNummer);
      })
      .catch((err) => console.error(err))
      .finally(() => setTimeout(() => isProcessing(false), 500));
  };

  useEffect(() => {
    setActive(forening.active);
    setValue("active", forening.active);
  }, [forening.active]);
  console.log("forening", forening)

  return (
    <>
      <form onSubmit={oppdaterForening}>
        <Input
          labelopts={labelopts}
          name="foreningsNummer"
          label="Foreningsnummer"
          value={forening.foreningsNummer}
          placeholder="Foreningsnummer"
          required
          id="foreningsNummer"
          type="number"
          onChange={handleForeningChange}
          ref={register}
          disabled={isViewer}
        />
        <Input
          labelopts={labelopts}
          name="foreningsNavn"
          label="Foreningsnavn"
          id="foreningsNavn"
          required
          value={forening.foreningsNavn}
          onChange={handleForeningChange}
          ref={register}
          className="w-1/2"
          placeholder="Foreningsnavn"
          disabled={isViewer}
        />
        <Input
          labelopts={labelopts}
          name="password"
          label="Passord"
          id="password"
          value={forening.password}
          onChange={handleForeningChange}
          ref={register}
          placeholder="Nytt passord"
          disabled={isViewer}
        />

        <Input
          name="active"
          label="Aktiv"
          id="active"
          type="checkbox"
          onChange={handleForeningChange}
          ref={register}
          labelopts={labelopts}
          checkbox={true}
          disabled={isViewer}
          defaultChecked={forening.active}
        />

        <Input
          name="viewer"
          label="Kan lese alle rapporter"
          id="viewer"
          type="checkbox"
          onChange={handleForeningChange}
          ref={register}
          labelopts={labelopts}
          checkbox={true}
          disabled={isViewer}
          defaultChecked={forening.viewer}
        />

        <div className="grid grid-cols-4 mt-4 place-content-evenly">
          {!isViewer && (
            <>
              <Button
              id="submit"
              type="submit"
              className={processingStyle}
              disabled={disabledStyle}
            >
              Oppdater forening
            </Button>
            <Button
              id="delete"
              type="button"
              onClick={fjernForening}
              className={processingStyle}
              disabled={disabledStyle}
            >
              Fjern Forening
            </Button>
            <Button
              type="button"
              onClick={openForeningRapport}
              className={processingStyle}
              disabled={disabledStyle}
            >
              Åpne Rapport
            </Button>
            </>
          )}
          <Button
            type="button"
            onClick={downloadReport}
            className={processingStyle}
            disabled={disabledStyle}
          >
            Last ned PDF
          </Button>
          {processing && <LoadingSpinnerComponent />}
        </div>
      </form>
    </>
  );
};

export default AdministrateForeningPanel;
